var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stepForm',{attrs:{"user":_vm.user,"request":_vm.request,"request-buttons":_vm.requestButtons,"btn-position":_vm.btnPosition},on:{"input":function($event){return _vm.$emit('input')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }